export default function mapRelationship(state, relationship) {
  if (relationship == null || Object.keys(relationship).length == 0) return null
  return state.objects?.[relationship?.type]?.[relationship?.id]
}
